import tracker from '../../../service/tracker';
import { biUserAction, bqEnrichment } from '../../../../../shared/services/BIEvents/utils';
import { BI_EVENT_GROUPS } from '../../../../../shared/services/BIEvents/constants';
import { BI_CONSTS, BI_EVENTS } from './constants';

const commonEventData = ({ userId, pageCtxId, type }) => ({
    type,
    pageCtxId,
    page: {
        name: BI_CONSTS.PAGE_NAME
    },
    payload: {
        user: {
            id: userId
        },
        feature: {
            name: BI_CONSTS.FEATURE_NAME
        }
    }
});

const reportUserActionEvent = ({ listingsType, query, pageCtxId, userId, type, callTracker }) => {
    const biEventData = commonEventData({
        userId,
        pageCtxId,
        type
    });

    callTracker({ listingsType, query });
    biUserAction(biEventData);
};

export const getBannerImpressionEnrichment = (userId, pageCtxId) => {
    const eventData = commonEventData({
        userId,
        pageCtxId,
        type: BI_EVENTS.BANNER_IS_SHOWN
    });

    return bqEnrichment({ group: BI_EVENT_GROUPS.USER_IMPRESSION, ...eventData });
};

export const reportVideoWatch = (context) => (
    reportUserActionEvent({
        ...context,
        type: BI_EVENTS.WATCH_VIDEO_CLICKED,
        callTracker: (context) => tracker.trackWebsiteMatchVideo(context)
    })
);

export const reportWebsiteMatch = (context) => (
    reportUserActionEvent({
        ...context,
        type: BI_EVENTS.CREATE_WEBSITE_CLICKED,
        callTracker: (context) => tracker.trackWebsiteMatchCta(context)
    })
);
